import { useReducer, useEffect } from 'react'
import { Col, Row, Select, Input } from 'antd'
import LoadingButton from '@mui/lab/LoadingButton'
import { backendGetRequest } from '../../../helpers/callBackend'
import { errorMessage } from '../../../helpers/errorMessageFunc'

const reducer = (state, action) => {
  switch (action.type) {
    case 'GET_START':
      // action.payload must be the total expected number of counterparties
      return {
        ...state,
        loading: true,
        totalCounterparties: action.payload,
      }
    case 'GET_SUCCESS':
      // action.payload is an array of paginated counterparties
      const loadingDone =
        state.totalCounterparties > 0 &&
        state.counterparties.length + action.payload.length >= state.totalCounterparties

      const newOptions = action.payload.map((cpty) => {
        return {
          value: cpty.id,
          label: cpty.name,
        }
      })

      // Combine and sort selectOptions by label alphabetically
      const sortedOptions = [...state.selectOptions, ...newOptions].sort((a, b) => a.label.localeCompare(b.label))

      return {
        ...state,
        loading: !loadingDone,
        counterparties: [...state.counterparties, ...action.payload],
        selectOptions: sortedOptions,
      }
    case 'SELECT_CHANGE':
      // action.payload is either a counterparty id or undefined
      return {
        ...state,
        currentValue: action.payload,
      }
    case 'INPUT_CHANGE':
      // actions.payload is either a string or undefined
      return {
        ...state,
        currentNewName: action.payload,
      }
    case 'UPDATE_START':
      return {
        ...state,
        updating: true,
      }
    case 'UPDATE_SUCCESS':
      return {
        ...state,
        updating: false,
      }
    default:
      return state
  }
}

const getCounterPartiesPage = async (pageNum, dispatch) => {
  try {
    const cptyResp = await backendGetRequest('/api/transactions/counterparties', {
      params: {
        page_index: pageNum,
        filter_params: {
          is_valid: true,
          clean_counterparty: 'None',
        },
      },
    })
    const cptyArray = cptyResp.data?.data

    if (!cptyArray) {
      throw new Error('No counterparties information found')
    }

    dispatch({ type: 'GET_SUCCESS', payload: cptyArray })
  } catch (error) {
    errorMessage(error.message)
  }
}

const getCounterParties = async (dispatch) => {
  let totalPages = 0
  try {
    const pageInfo = await backendGetRequest('/api/transactions/counterparties', {
      params: {
        page_index: 0,
        filter_params: {
          is_valid: true,
          clean_counterparty: 'None',
        },
      },
    })
    totalPages = pageInfo.data?.total_pages
    dispatch({ type: 'GET_START', payload: pageInfo.data?.total_records })
  } catch (error) {
    errorMessage(error.message)
  }

  for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
    getCounterPartiesPage(pageNum, dispatch)
  }
}

const SelectCleanCounterparty = ({
  handleCounterpartyNameChange,
  handleCounterpartyAssign,
  setCounterpartyEditable,
}) => {
  const defaultState = {
    loading: true,
    updating: false,
    counterparties: [],
    totalCounterparties: -1,
    selectOptions: [],
    currentValue: undefined,
    currentNewName: undefined,
  }

  const [state, dispatch] = useReducer(reducer, defaultState)

  const onSubmit = () => {
    if (state.currentValue == -1) {
      // entering new name for counterparty
      if (!state.currentNewName) {
        errorMessage('Please enter a new counterparty name')
        return
      }
      handleCounterpartyNameChange(state.currentNewName)
    } else {
      // assigning new counterparty
      if (!state.currentValue) {
        errorMessage('Please select a counterparty')
        return
      }
      handleCounterpartyAssign(state.currentValue)
    }
  }

  useEffect(() => {
    getCounterParties(dispatch)
  }, [getCounterParties])

  return (
    <Col span={24}>
      <Row>
        <Select
          style={{ width: '70%', marginRight: '10px', marginBottom: '10px' }}
          showArrow
          showSearch
          dropdownStyle={{ maxHeight: 400, overflow: 'auto', zIndex: 2000 }}
          placeholder='Select counterparty'
          allowClear
          optionFilterProp='label'
          options={[...state.selectOptions, { value: -1, label: 'Other, please specify' }]}
          value={state.currentValue}
          onChange={(value) => {
            dispatch({ type: 'SELECT_CHANGE', payload: value })
          }}
        />
      </Row>
      <Row>
        {state.currentValue === -1 && (
          <Input
            style={{
              width: '70%',
              marginRight: '10px',
            }}
            placeholder='Enter other name'
            allowClear
            type='text'
            disabled={state.currentValue == undefined || state.currentValue >= 0}
            onChange={(event) => {
              dispatch({ type: 'INPUT_CHANGE', payload: event.currentTarget.value })
            }}
          />
        )}
      </Row>
      <LoadingButton
        loading={state.updating}
        sx={{ fontSize: 12, textTransform: 'none', width: '60px', marginRight: '10px', marginTop: '10px' }}
        disableElevation
        fullWidth
        size='small'
        type='submit'
        variant='outlined'
        color='secondary'
        htmlType='submit'
        disabled={state.loading || state.updating}
        onClick={onSubmit}
      >
        Submit
      </LoadingButton>
      <LoadingButton
        loading={state.updating}
        sx={{ fontSize: 12, textTransform: 'none', width: '60px', marginTop: '10px' }}
        disableElevation
        fullWidth
        size='small'
        type='submit'
        variant='outlined'
        color='secondary'
        htmlType='submit'
        onClick={() => {
          setCounterpartyEditable(false)
        }}
      >
        Cancel
      </LoadingButton>
    </Col>
  )
}

export default SelectCleanCounterparty
